'use client'

import clsx from 'clsx'
import { useTranslations } from 'next-intl'

import ProfileTabsS from '@/app/[locale]/profile/components/ProfileTabs/ProfileTabs.module.scss'

import S from './ClubProfileTabs.module.scss'

export type ClubProfileTab =
  | 'overview'
  | 'analytics'
  | 'fansLeaderboard'
  | 'monetization'

export const ALL_CLUB_PROFILE_TABS = [
  'overview',
  'fansLeaderboard',
  'analytics',
  'monetization'
] as const satisfies readonly ClubProfileTab[]

// Shown with a "Soon" badge and not selectable until the feature ships.
export const SOON_CLUB_PROFILE_TABS: ReadonlySet<ClubProfileTab> = new Set()

interface ClubProfileTabsProps {
  tabs: readonly ClubProfileTab[]
  activeTab: ClubProfileTab
  onTabChange: (tab: ClubProfileTab) => void
  /** Tabs shown with «Soon» and not selectable. */
  soonTabs?: ReadonlySet<ClubProfileTab>
}

const ClubProfileTabs = ({
  tabs,
  activeTab,
  onTabChange,
  soonTabs = SOON_CLUB_PROFILE_TABS
}: ClubProfileTabsProps) => {
  const t = useTranslations('club')

  return (
    <div className={ProfileTabsS.tabs}>
      {tabs.map(tab => {
        const isSoon = soonTabs.has(tab)

        return (
          <button
            key={tab}
            type="button"
            className={clsx(
              ProfileTabsS.tab,
              activeTab === tab && ProfileTabsS.tabActive,
              isSoon && S.tabSoon
            )}
            aria-disabled={isSoon || undefined}
            tabIndex={isSoon ? -1 : undefined}
            onClick={() => !isSoon && onTabChange(tab)}
          >
            {t(`tabs.${tab}`)}
            {isSoon && (
              <>
                {' '}
                <span className={S.soonBadge}>{t('activation.soonBadge')}</span>
              </>
            )}
            {activeTab === tab && <div className={ProfileTabsS.underline} />}
          </button>
        )
      })}
    </div>
  )
}

export default ClubProfileTabs
